export enum AchievementTaskType {
	CompleteAchievement = 1,
	UnlockAchievement = 2,
}
